let _navigate;

export const setNavigator = (nav) => {
    _navigate = nav;
};

export const navigateTo = (path) => {
    if (_navigate) _navigate(path, { replace: true });
};
